<template>
  <div class="recipient-wrapper" :class="{ 'has-border': isOrderDetail }">
    <div class="address-head">
      <h5 :class="{ 'is-details': isOrderDetail }">Shipping Address</h5>
      <router-link
        tag="button"
        :to="{ name: 'AddRecipient', query: { editing: 1 } }"
        class="whitebutton-gemnote whitebutton-gemnote--tiny"
        v-if="showEditButtons"
        >Edit</router-link
      >
    </div>
    <div class="address-content">
      <div class="address-detail">
        <p>
          {{ recipient.attributes ? recipient.attributes.name : '' }}
        </p>
        <p v-if="recipient.attributes.email">
          {{ recipient.attributes.email }}
        </p>
        <p v-if="recipient.attributes.company">
          {{ recipient.attributes.company }}
        </p>
        <p v-if="recipient.attributes.addressOne">
          {{ recipient.attributes.addressOne }}
        </p>
        <p v-if="recipient.attributes.addressTwo">
          {{ recipient.attributes.addressTwo }}
        </p>
        <p>{{ locationDetail }}</p>
      </div>
      <div class="address-map hidden">
        <img class="map-img" :src="mapsImgUrl" />
      </div>
    </div>
    <div class="tracking-number inter" v-if="trackingNumber">
      <p>Tracking Number</p>
      <span v-if="trackingURL">
        <a :href="trackingURL" target="_blank">{{ trackingNumber }}</a>
      </span>
      <span v-else>{{ trackingNumber }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressItem',
  props: {
    recipient: {
      type: Object
    },
    trackingNumber: {
      type: String
    },
    trackingURL: {
      type: String
    },
    showEditButtons: {
      type: Boolean,
      default: false
    },
    isOrderDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MAPS_API_KEY: process.env.VUE_APP_MAPS_API_KEY
    }
  },
  computed: {
    mapsImgUrl() {
      let address = this.recipient.attributes.addressOne
        ? this.recipient.attributes.addressOne
        : ''
      address = address.replace('#', '')
      let mapsUrlAddress = encodeURI(
        ` ${address},
        ${this.recipient.attributes.city},
        ${this.recipient.attributes.state}`
      )
      let mapsUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${mapsUrlAddress}&zoom=15&size=170x150&markers=size:small%7Ccolor:black%7C${address},${this.recipient.attributes.city},${this.recipient.attributes.state}&key=${this.MAPS_API_KEY}`
      return mapsUrl
    },
    locationDetail() {
      let location = ''

      if (
        this.recipient.attributes.city &&
        this.recipient.attributes.state &&
        this.recipient.attributes.zipcode
      ) {
        location = `${this.recipient.attributes.city}, ${this.recipient.attributes.state} ${this.recipient.attributes.zipcode} `
      } else if (
        !this.recipient.attributes.city &&
        this.recipient.attributes.state &&
        this.recipient.attributes.zipcode
      ) {
        location = `${this.recipient.attributes.state} ${this.recipient.attributes.zipcode}`
      }
      return location
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/global.scss';

.recipient-wrapper {
  padding: 1.75rem;
  width: 100%;
  height: 100%;
  background: $dark-gray;
}

.address-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;

  h5 {
    font-family: $inter;
    font-size: 0.875rem;
    text-align: left;
    font-weight: bold;

    &.is-details {
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.address-content {
  align-items: center;
  display: flex;
  /* flex-wrap: wrap; */

  p {
    margin-bottom: 0.3rem;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
  }

  .address-detail {
    width: 100%;

    p {
      font-size: 0.813rem;
      line-height: 23px;
      word-wrap: break-word;
      width: 90%;
    }
  }

  .address-map {
    width: 100%;
    margin-left: auto;
  }
}

.tracking-number {
  display: flex;
  align-items: center;
  margin-top: 2rem;
  gap: 10px;
  align-items: center;

  p {
    padding-right: 1.4rem;
    text-align: left;
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 600;
  }

  span {
    font-size: 13px;

    a {
      text-decoration: none;
    }
  }
}

.whitebutton-gemnote--tiny {
  width: 76px;
  height: 30px;
  font-size: 0.875rem;
  font-weight: 400;
}
</style>
